/* LEDPLANET lp-gratis-verzending.js (17-10-2026): werking van snippets/ledplanet-gratis-verzending (groene balk onder de prijs) als gecacht bestand.
   De gegevens per pagina (land, voorraad en prijs per variant, winkelwagen) staan inline in window.LP_GV_DATA; dit bestand wordt direct
   daarna synchroon geladen, op dezelfde plek als het oude inline script. De opmaak blijft inline in het snippet. Wijzig de werking HIER.
   28-10-2026 eigenaar ('verzending gratis klopt niet'):
   - het land komt nu uit de centrale levertijd (LP_LEVERTIJD.land(): gekozen bezorgland, Shopify-markt of locatie), net als de blauwe
     USP-balk, de productkaarten en de winkelwagen. Voorheen gebruikte deze balk alleen het Shopify-land, waardoor bv. een bezoeker met
     bezorgland Duitsland in de Nederlandse markt 'Kostenloser Versand' zag bij 60,95 (Duitsland: gratis vanaf 100).
   - een variant die al in de winkelwagen zit telt niet meer dubbel (winkelwagen + nog eens dit artikel).
   - land zonder verzendtarief (bv. CY): alleen de voorraadregel, geen belofte over verzending. */
(function () {
  // GRENZEN (euro): [gratis vanaf, minimaal bestelbedrag (0 = geen)], gelijk aan Instellingen > Verzending
  var EU = ['AT','BG','HR','CZ','DK','EE','FI','FR','GR','HU','IE','IT','LV','LT','LU','MT','NO','PL','PT','RO','SK','SI','ES','SE','CH','GB'];
  var G = { NL: [50, 0], BE: [50, 0], DE: [100, 0] };
  EU.forEach(function (c) { G[c] = [150, 100]; });
  var D = window.LP_GV_DATA || {};
  function landNu() {
    var c = null;
    try { c = window.LP_LEVERTIJD && window.LP_LEVERTIJD.land && window.LP_LEVERTIJD.land(); } catch (e) {}
    return String(c || D.land || 'NL').toUpperCase();
  }

  var TAAL = ((document.documentElement.lang || 'nl').slice(0, 2)).toLowerCase();
  var T = {
    nl: { gratis: 'Gratis verzending', naar: 'naar {l}', nog: 'Gratis verzending naar {l} vanaf {g}', nogx: 'Nog {x} tot gratis verzending', min: 'Verzending naar {l} vanaf {m}, gratis vanaf {g}' },
    de: { gratis: 'Kostenloser Versand', naar: 'nach {l}', nog: 'Kostenloser Versand nach {l} ab {g}', nogx: 'Noch {x} bis zum kostenlosen Versand', min: 'Versand nach {l} ab {m}, kostenlos ab {g}' },
    en: { gratis: 'Free shipping', naar: 'to {l}', nog: 'Free shipping to {l} from {g}', nogx: '{x} to go for free shipping', min: 'Shipping to {l} from {m} order value, free from {g}' },
    fr: { gratis: 'Livraison gratuite', naar: '{l}', nog: 'Livraison gratuite {l} dès {g}', nogx: 'Plus que {x} pour la livraison gratuite', min: 'Livraison {l} dès {m}, gratuite dès {g}' },
    es: { gratis: 'Envío gratis', naar: 'a {l}', nog: 'Envío gratis a {l} desde {g}', nogx: 'Faltan {x} para el envío gratis', min: 'Envío a {l} desde {m}, gratis desde {g}' },
    it: { gratis: 'Spedizione gratuita', naar: 'in {l}', nog: 'Spedizione gratuita in {l} da {g}', nogx: 'Mancano {x} alla spedizione gratuita', min: 'Spedizione in {l} da {m}, gratuita da {g}' },
    pl: { gratis: 'Darmowa wysyłka', naar: 'do: {l}', nog: 'Darmowa wysyłka do: {l} od {g}', nogx: 'Brakuje {x} do darmowej wysyłki', min: 'Wysyłka do: {l} od {m}, darmowa od {g}' }
  };
  var V = {
    nl: ['Niet op voorraad', 'Op voorraad', 'Leverbaar', 'uiterlijk'], de: ['Nicht auf Lager', 'Auf Lager', 'Lieferbar', 'spätestens'],
    en: ['Out of stock', 'In stock', 'Available', 'at the latest'], fr: ['En rupture de stock', 'En stock', 'Disponible', 'au plus tard'],
    es: ['Agotado', 'En stock', 'Disponible', 'como muy tarde el'], it: ['Esaurito', 'Disponibile', 'Ordinabile', 'al più tardi'],
    pl: ['Brak w magazynie', 'W magazynie', 'Dostępny', 'najpóźniej']
  }[TAAL] || ['Out of stock', 'In stock', 'Available', 'at the latest'];
  var VR = D.vr || {};
  window.LP_GV_ACTIEF = true;   // ledplanet-productpagina-compact laat dan geen eigen voorraadregel zien
  // ik verstuur vanuit Nederland: binnen Nederland 'binnen' i.p.v. 'naar' (alleen in de 'vanaf'-tekst; de kop is dan gewoon 'Gratis verzending')
  var BINNEN = {
    nl: { nog: 'Gratis verzending binnen Nederland vanaf {g}', min: 'Verzending binnen Nederland vanaf {m}, gratis vanaf {g}' },
    de: { nog: 'Kostenloser Versand innerhalb der Niederlande ab {g}', min: 'Versand innerhalb der Niederlande ab {m}, kostenlos ab {g}' },
    en: { nog: 'Free shipping within the Netherlands from {g}', min: 'Shipping within the Netherlands from {m}, free from {g}' },
    fr: { nog: 'Livraison gratuite aux Pays-Bas dès {g}', min: 'Livraison aux Pays-Bas dès {m}, gratuite dès {g}' },
    es: { nog: 'Envío gratis dentro de los Países Bajos desde {g}', min: 'Envío dentro de los Países Bajos desde {m}, gratis desde {g}' },
    it: { nog: 'Spedizione gratuita nei Paesi Bassi da {g}', min: 'Spedizione nei Paesi Bassi da {m}, gratuita da {g}' },
    pl: { nog: 'Darmowa wysyłka w Holandii od {g}', min: 'Wysyłka w Holandii od {m}, darmowa od {g}' }
  };
  function naamVan(land) {
    var n = land;
    try { n = new Intl.DisplayNames([TAAL], { type: 'region' }).of(land) || land; } catch (e) {}
    // Frans met het juiste voorzetsel: 'en Belgique', 'aux Pays-Bas', 'au Portugal' (17-10-2026)
    if (TAAL === 'fr') n = ({ NL: 'aux ', PT: 'au ', DK: 'au ', LU: 'au ' }[land] || 'en ') + n;
    return n;
  }

  var rate = 1;
  try { rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1) || 1; } catch (e) {}
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  var loc = (document.documentElement.lang || 'nl-NL');
  // geen euroteken; het woord euro achter het bedrag in de taal van de bezoeker (andere valuta: valutacode)
  var EW = { nl: 'euro', de: 'Euro', en: 'euros', fr: 'euros', es: 'euros', it: 'euro', pl: 'euro' };
  function geld(cent) {
    var v = cent / 100, s;
    try { s = new Intl.NumberFormat(loc, { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(v); } catch (e) { s = v.toFixed(2).replace('.', ','); }
    return s + ' ' + (cur === 'EUR' ? (EW[TAAL] || 'euro') : cur);
  }

  var PRIJS = D.prijs || {};
  var EERSTE = D.eerste;
  var wagen = D.wagen || 0;
  var IN = D.inwagen || {};   // variant-id -> aantal dat al in de winkelwagen zit

  var VINKJE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
  var KLOK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';
  function kortDatum(d) { try { return new Intl.DateTimeFormat(TAAL === 'en' ? 'en-GB' : TAAL, { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }).format(d).replace(/[.,]/g, ''); } catch (e) { return ''; } }
  function klein1(s) { return s.charAt(0).toLowerCase() + s.slice(1); }
  var TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 3h15v13H1z"/><path d="M16 8h4l3 3v5h-7z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
  var MOBIEL = window.matchMedia('(max-width: 768.98px)');

  function form() { return document.querySelector('.product-info form[action*="/cart/add"]:not(.js-instalments-form), form[action*="/cart/add"][id*="product-form"], form[action*="/cart/add"]'); }
  function variantId() {
    var f = form(); var i = f && f.querySelector('[name="id"]');
    var v = i && i.value ? i.value : (new URLSearchParams(location.search).get('variant') || EERSTE);
    return String(v);
  }
  function aantal() {
    var q = document.querySelector('.product-info input[name="quantity"], form[action*="/cart/add"] input[name="quantity"], input[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return n > 0 ? n : 1;
  }
  /* 23-10-2026 (3) eigenaar: titel helemaal bovenaan; de groene balk staat onderaan bij de USP's (garantie, bedenktijd e.d.) en vormt daarmee
     één groen blok. De USP 'Verzendkosten ... tot gratis verzending' verdwijnt, want dat staat al in de balk. Geen USP-lijst: boven de bestelknop. */
  var VERZ = /verzend|verzond|shipping|shipped|versand|livraison|livré|env[ií]o|enviad|spedizion|spedit|wysy[łl]k/i;   // 23-10-2026: ook 'Je grondspots worden gratis verzonden!'
  function usps() { return document.querySelector('.cc-main-product #productUSPs'); }
  function plek() {
    var u = usps();
    if (u) {
      [].forEach.call(u.querySelectorAll('li'), function (li) { if (VERZ.test(li.textContent) && !li.classList.contains('lp-gv-weg')) li.classList.add('lp-gv-weg'); });
      return u;
    }
    var knop = document.querySelector('.cc-main-product button[name="add"]');
    var blok = knop && knop.closest('.product-info__block');
    if (blok) return blok;
    var p = document.querySelector('.product-info__sticky h1, .product-info h1, .product-info__sticky .product-title, .product-info .price');
    if (!p) return null;
    return p.closest('.product-info__block') || p;
  }
  function stijl() {
    if (document.getElementById('lp-gv-samen-css')) return;
    var s = document.createElement('style'); s.id = 'lp-gv-samen-css';
    s.textContent = '.product-usps li.lp-gv-weg{display:none!important}'
      + '.lp-gv-samen .lp-gv{margin:0!important;border-bottom-left-radius:0!important;border-bottom-right-radius:0!important;border-bottom:0!important}'
      + '.lp-gv-samen #productUSPs{background:#F4FBF6!important;border:1px solid #D3EEDC!important;border-top:1px solid #E3F3E8!important;border-radius:0 0 10px 10px!important;margin-top:0!important}'
      + '.lp-gv-samen #productUSPs .icon{background:#fff!important}'
      + '.lp-gv-solo .lp-gv{margin:0!important}';
    document.head.appendChild(s);
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function teken() {
    var ref = plek(); if (!ref) return;
    var el = document.querySelector('.lp-gv');
    if (!el) { el = document.createElement('div'); el.setAttribute('role', 'status'); }
    if (el.nextElementSibling !== ref) ref.parentNode.insertBefore(el, ref);
    stijl();
    if (ref.id === 'productUSPs') {
      var zicht = [].some.call(ref.querySelectorAll('li'), function (li) { return getComputedStyle(li).display !== 'none'; });
      var bl = ref.parentNode;
      bl.classList.toggle('lp-gv-samen', zicht);
      bl.classList.toggle('lp-gv-solo', !zicht);
      ref.style.display = zicht ? '' : 'none';
    }
    // land en grenzen per keer bepalen: de bezoeker kan intussen een ander bezorgland kiezen
    var LAND = landNu(), grens = G[LAND];
    var L = T[TAAL] || T.en;
    if (LAND === 'NL') L = Object.assign({}, L, BINNEN[TAAL] || BINNEN.en);
    var landNaam = naamVan(LAND);
    var grensCent = grens ? Math.round(grens[0] * 100 * rate) : 0, minCent = grens ? Math.round(grens[1] * 100 * rate) : 0;
    function tekst(s, x) { return s.replace('{l}', landNaam).replace('{g}', geld(grensCent)).replace('{m}', geld(minCent)).replace('{x}', x || ''); }

    var vid = variantId();
    var st = VR[vid] !== undefined ? VR[vid] : VR[EERSTE];
    // zit deze variant al in de winkelwagen, dan telt alleen de winkelwagen (anders werd het artikel dubbel geteld)
    var totaal = (IN[vid] ? 0 : (PRIJS[vid] || PRIJS[EERSTE] || 0) * aantal()) + wagen;
    var gratis = grens ? totaal >= grensCent : false, minGeval = minCent > 0 && totaal < minCent;
    // regel 1: voorraad · verzending (land zonder verzendtarief: alleen de voorraad)
    var verz = !grens ? '' : (gratis ? L.gratis + (LAND === 'NL' ? '' : ' ' + tekst(L.naar)) : (minGeval ? tekst(L.min) : tekst(L.nogx, geld(grensCent - totaal))));
    var samen = ref.id === 'productUSPs';   // onderaan bij de USP's: voorraad + levertijd staan al boven de bestelknop
    var kop;
    if (!verz) kop = esc(V[st] || V[0]);
    else kop = samen && st ? esc(verz) : (st ? esc(V[st]) + '<em>·</em>' + esc(gratis ? verz : klein1(verz)) : esc(V[0]));
    kop = '<span class="lp-gv__k">' + kop + '</span>';
    // regel 2: echte bezorgdatum + vervoerder (centrale levertijd), anders de levertijdtekst van het profiel
    var sub = '', soort = st === 1 ? 'ja' : (st === 2 ? 'lev' : 'uit');
    if (st && !samen) {
      var r = null, dt = null, pt = null;
      try { r = window.LP_LEVERTIJD.productRegel(); dt = window.LP_LEVERTIJD.datum(); } catch (e) {}
      if (r && r.tekst) {
        var kl = (dt && dt.bereik) ? '(' + V[3] + ' ' + kortDatum(dt.tot) + ')' : '';
        sub = esc(r.tekst + r.met) + (kl ? ' <small>' + esc(kl) + '</small>' : '');
      } else {
        try { pt = window.LP_LEVERTIJD.productTekst(''); } catch (e) {}
        if (pt && pt.text) { sub = esc(pt.text); soort = 'lev'; }
      }
    }
    var balk = (grens && !gratis && st) ? '<span class="lp-gv__b"><i style="width:' + Math.max(4, Math.min(100, Math.round(totaal / grensCent * 100))) + '%"></i></span>' : '';
    var html = '<span class="lp-gv__i">' + (samen && st ? TRUCK : (st === 1 ? VINKJE : (st ? TRUCK : KLOK))) + '</span><span class="lp-gv__t">' + kop + (sub ? '<span class="lp-gv__s">' + sub + '</span>' : '') + balk + '</span>';
    var cls = 'lp-gv lp-gv--v2 lp-gv--' + soort;
    if (el.className !== cls) el.className = cls;
    if (el.innerHTML !== html) el.innerHTML = html;
    el.setAttribute('data-lp-land', LAND);
  }
  var wacht;
  function later() { clearTimeout(wacht); wacht = setTimeout(teken, 150); }
  function wagenOphalen() {
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
      wagen = c.total_price || 0; IN = {};
      (c.items || []).forEach(function (i) { IN[i.variant_id] = (IN[i.variant_id] || 0) + i.quantity; });
      teken();
    }).catch(function () {});
  }
  function start() {
    teken();
    document.addEventListener('change', later, true);
    document.addEventListener('input', later, true);
    document.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('quantity-input, .quantity__button, [name="plus"], [name="minus"], variant-picker, .variant-picker, .opt-btn')) later(); }, true);
    document.addEventListener('variant:change', later);
    document.addEventListener('on:variant:change', later);
    document.addEventListener('lp:levertijd-tik', later);
    document.addEventListener('lp:levertijd-update', later);
    if (MOBIEL.addEventListener) MOBIEL.addEventListener('change', later);
    // de voorraadregel komt iets later (ledplanet-productpagina-compact): dan pas de datum in deze regel
    [600, 1500, 3000].forEach(function (t) { setTimeout(teken, t); });
    // winkelwagen bijgewerkt (toegevoegd, aantal gewijzigd of verwijderd): opnieuw ophalen
    ['on:cart:add', 'on:cart:change', 'on:line-item:change', 'cart:updated'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(wagenOphalen, 300); }); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
